<template>
  <div>
    <define-table :data="userList" :height="`${userList.length * 48 + 90}px`" @rowDblclick="selected"
                  style="width: 100%" @changeCurrent="change" :highLightCurrent="true" :pageInfo="pageInfo" @changePage="changePage">
      <define-column label="所属角色" v-slot="{ data }">
          <span v-if="data.row.userRole === 'PANTOU_WORKER'">盘头工</span>
          <span v-if="data.row.userRole === 'CRAFTSMEN'">工艺工</span>
          <span v-if="data.row.userRole === 'PRODUCTION_WORKER'">生产工</span>
          <span v-if="data.row.userRole === 'PERCHER'">验布工</span>
          <span v-if="data.row.userRole === 'REPAIR_WORKER'">维修工</span>
          <span v-if="data.row.userRole === 'FACTORY_MANAGER'">厂长</span>
          <span v-if="data.row.userRole === 'PLANT_MANAGER'">工厂管理员</span>
          <span v-if="data.row.userRole === 'INTEGRATED_SERVICE_PROVIDER'">集成服务商</span>
        </define-column>
      <define-column field="number" label="职员卡号"></define-column>
      <define-column field="username" label="用户名称"></define-column>
      <define-column field="phone" label="联系电话"></define-column>
    </define-table>

    <div class="footer">
      <el-button type="danger" @click="cancel">取消</el-button>
      <el-button type="primary" @click="selected">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user',
  data () {
    return {
      userList: [],
      select: {},
      pageInfo: {
        page: 1,
        size: 8,
        totalPages: 1
      }
    }
  },
  methods: {
    change (val) {
      this.select = val.current
    },
    cancel () {
      this.$emit('cancel')
    },
    selected () {
      this.$emit('select', { data: this.select, ref: 'user' })
    },
    changePage (val) {
      this.pageInfo.page = val
      this.$request({
        url: '/Worker/workerList',
        method: 'GET',
        params: this.pageInfo
      },true).then(res => {
          this.userList = res.data.content
          this.pageInfo.totalPages = res.data.totalPages
      }).catch(() => {
        this.$Message.error('用户列表获取失败')
      })
    }
  },
  created () {
    this.changePage(1)
  }
}
</script>

<style scoped>
.footer {
  margin: 10px;
  display: flex;
  justify-content: flex-end;
}
.add {
  float: right;
}
</style>
